import { Button, IconButton } from "@mui/material";
import { useIsMobile } from "@tlc/ui/useIsMobile";
import React from "react";
import { useLanguage } from "@tlc/ls2pac/components/Language";
import { useSaveSearchDialog } from "./SaveSearchDialog";
import BookmarkIcon from "@mui/icons-material/Bookmark";

export const SaveSearchButton = () => {
  const isMobile = useIsMobile();
  const { translate } = useLanguage();
  const { showDialog } = useSaveSearchDialog();

  if (isMobile) {
    return (
      <IconButton
        color="primary"
        aria-label={translate("saveSearch")}
        onClick={showDialog}
      >
        <BookmarkIcon />
      </IconButton>
    );
  }

  return (
    <Button startIcon={<BookmarkIcon />} onClick={showDialog}>
      {translate("saveSearch")}
    </Button>
  );
};
